import { useContext, useEffect, useState } from "react";
import { MenuItem, TextField } from '@mui/material';
import BuilderContext from '../../../../store/BuilderContext';
import AuthContext from "../../../../store/AuthContext";

const Gap = (props) => {

  const { blockId, screenType } = props;
  const builderCtx = useContext(BuilderContext);
  const authCtx = useContext(AuthContext);
  const { contentBlocks, updateContentBlocks, currentContentBlock, updateCurrentBlock } = builderCtx;

  const getCurrentBlockStyles = () => {
    switch ( screenType ) {
      case "mobile" :
        return currentContentBlock?.mobileStyling;
      break;
      case "horizontal":
        return currentContentBlock?.horizontalStyling;
      break;
      case "vertical":
        return currentContentBlock?.verticalStyling;
      break;
      default:
        return currentContentBlock?.styling;
      break;
    }
  }

  const currentBlockStyles = getCurrentBlockStyles()
  const currentGap = currentBlockStyles?.gap?.match(/[a-zA-Z]+|[0-9]+|[%]/g);

  const units = [
    { value: 'px', label: 'px' },
    { value: 'rem', label: 'rem' },
    { value: '%', label: '%' },
    { value: 'vh', label: 'vh' },
    { value: 'vw', label: 'vw' },
  ];

  const [gap, setGap] = useState(currentGap?.[0] || "auto");
  const [unit, setUnit] = useState(currentGap?.[1] || "px");
  const [finalValue, setFinalValue] = useState("");

  const [onChangeFlag, setOnChangeFlag] = useState(false);

  if (gap !== "auto") localStorage.setItem("preGap", gap);

  const handleUnitChange = (e) => {
    setOnChangeFlag(true);

    if (!e.target.value) {
      setGap("auto");
    } else {
      setUnit(e.target.value);
      if (localStorage.getItem("preGap")) {
        setGap(localStorage.getItem("preGap"));
      }
    }
  };

  const updateGap = (gapValue, unit) => {
    let payload = {
      id: blockId,
      value: gapValue !== 'auto' ? gapValue + unit : gapValue,
      screenType: props?.screenType
    }

    fetch(process.env.REACT_APP_API_URI + '/v3/admin/assessment/styling/gap', {
      method: 'PUT',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authCtx.token },
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(data => {
        if (data.status === "success") {
          console.log("Updating gap payload", payload);
        }
      }).catch((err) => {
        console.error("Failed to update gap...", err);
      });
  }

  useEffect(() => {
    if (gap === "auto") {
      setFinalValue("auto");
    } else if (gap && gap !== "auto" && unit) {
      if (gap !== currentGap?.[0] || unit !== currentGap?.[1]) {
        setFinalValue(`${gap}${unit}`);
      }
    }
  }, [currentGap, gap, unit]);

  useEffect(() => {
    let lastFinalVal = "";
    if (!currentGap?.[1]) {
      lastFinalVal = "auto";
    } else {
      lastFinalVal = currentGap?.[0] + currentGap?.[1];
    }

    if (onChangeFlag) {
      updateGap(gap, unit);
    }

    const timer = setTimeout(() => {
      if (finalValue && finalValue !== lastFinalVal) {
        // updateContentBlocks(contentBlocks?.map(block => {
        //   if (block.id === blockId) {
        //     let newStyles = { ...block.styling };
        //     newStyles.gap = finalValue;
        //     block.styling = { ...newStyles };
        //     return block;
        //   } else {
        //     return block;
        //   }
        // }))

        switch ( screenType ) {
          case "mobile" : 
            updateContentBlocks(contentBlocks?.map(block => {
              if (block.id === blockId) {
                return {
                  ...block,
                  mobileStyling: {
                    ...block.mobileStyling,
                    gap: finalValue
                  }
                };
                              }
              if (block.id === blockId ) {
                updateCurrentBlock(block)
              }
              return block;
            }));
          break;
          case "horizontal" :
            updateContentBlocks(contentBlocks?.map(block => {
              if (block.id === blockId) {
                return {
                  ...block,
                  horizontalStyling: {
                    ...block.horizontalStyling,
                    gap: finalValue
                  }
                };
                              }
              if (block.id === blockId ) {
                updateCurrentBlock(block)
              }
              return block;
            }));
          break;
          case "vertical" :
            updateContentBlocks(contentBlocks?.map(block => {
              if (block.id === blockId) {
                return {
                  ...block,
                  verticalStyling: {
                    ...block.verticalStyling,
                    gap: finalValue
                  }
                };
                              }
              if (block.id === blockId ) {
                updateCurrentBlock(block)
              }
              return block;
            }));
          break;
          default:
            updateContentBlocks(contentBlocks?.map(block => {
              if (block.id === blockId) {
                return {
                  ...block,
                  styling: {
                    ...block.styling,
                    gap: finalValue
                  }
                };
                              }
              if (block.id === blockId ) {
                updateCurrentBlock(block)
              }
              return block;
            }));
          break;
        }
      }

      setOnChangeFlag(false);
    }, 500);

    return () => clearTimeout(timer);

  }, [blockId, finalValue, unit]);

  return (
    <div className="gap tool">
      {props.deleteModal}
      <TextField id="gap-number" className="gap-input styling-input" type="number" variant="filled"
        InputLabelProps={{ shrink: true }} placeholder={gap + ""} value={gap}
        onChange={(e) => {
          if (e.target.value) {
            setGap(e.target.value);
          } else {
            setGap("auto");
          }
          setOnChangeFlag(true)
        }} />

      <TextField className="gap-unit styling-select" select variant="standard" InputProps={{ disableUnderline: true }}
        placeholder={currentContentBlock.styling?.gap + ""} value={unit} onChange={(e) => {
          handleUnitChange(e);
        }}>
        {units?.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>

    </div>
  )
}

export default Gap;
